import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {AppScope} from '../app_scope.service';
import {TimezoneSelectorService} from "../timezone-selector.service";
import {firstValueFrom} from "rxjs";

export const urlGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const appScope: AppScope = inject(AppScope);
    const router: Router = inject(Router);
    const timezoneService: TimezoneSelectorService = inject(TimezoneSelectorService);

    const userLoaded = await firstValueFrom(appScope.userContextLoaded);
    if (!userLoaded) {
        console.error("User context was not loaded for url guard.");
        return false;
    }
    if (appScope.current_user.default_dashboard_id) {
        router.navigate(['view', 'page_view', appScope.current_user.default_dashboard_id]);
    } else {
        router.navigate(['view', 'page_list_view']);
    }
    timezoneService.refresh();
    return true;
};
